import { render, staticRenderFns } from "./barChartDialog.vue?vue&type=template&id=df56b35c&scoped=true"
import script from "./barChartDialog.vue?vue&type=script&lang=js"
export * from "./barChartDialog.vue?vue&type=script&lang=js"
import style0 from "./barChartDialog.vue?vue&type=style&index=0&id=df56b35c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df56b35c",
  null
  
)

export default component.exports